export const hongbao = {
    hb: "Red envelopes",
    dps: "Grande distribution",
    xdhb: "Red envelopes exclusifs, des milliers de avantages vous attendent",
    fxhb: "Partager des red envelopes, gagner plus de récompenses",
    khb: "Ouvrir un red envelope Biking",
    kqz: "En cours d'ouverture...",
    ylq: "Déjà réclames",
    hdwks: "Activité non démarrée",
    hdjxz: "Activité en cours",
    hdyjs: "Activité terminée",
    hddjs: "Compte à rebours de l'activité",
    hdsj: "Période de l'activité",
    zwhd: "Aucune activité",
    hblsjlxq: "Historique de mes red envelopes",
    jxz: "En cours",
    ygq: "Expiré",
    dks: "À démarrer",
    zwjl: "Aucune récompense",
    wnmztj: "Vous ne remplissez pas les conditions de l'activité",
    wxts: "Astuce",
    yhwcrz: "L'utilisateur a complété la vérification KYC et lié son numéro de téléphone",
    yhwcjy: "L'utilisateur a réalisé au moins l'une des conditions : trading spot ≥100 USDT, ou trading à terme (sans levier) ≥100 USDT, ou options ≥100 USDT, ou GameFi ≥100 USDT",
    djzh: "Les comptes sous contrôle de risque ou limités ne peuvent pas participer",
    hdhbjl: "Récompense de red envelope obtenue",
    sqbj: "Pas de chance",
    dkapp: "Ouvrir l'APP",
    smewm: "Scanner le QR code",
    wchdtj: "Remplissez les conditions pour réclamer le red envelope",
    fxhd: "Partager l'activité pour plus de red envelopes",
    jdzcz: "Opération simple, gains potentiels",
    hdhb: "Red envelope de l'activité",
    zdqj: "Période指定",
    wcjye: "Compléter un volume de {type} de {text} ≥ {amount} USDT",
    yhwfhtj: "Dans les {time} avant le red envelope, l'utilisateur n'a pas de transactions éligibles",
    hbsxq: "Dans les {time} {day} avant le red envelope, l'utilisateur {text}",
    bhgg: "Sans levier",
    h: "Ou",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/fr.js